import React from 'react'
import _ from 'lodash'
import { Col, FormGroup, FormControl, Radio } from 'react-bootstrap'

export default class MappingDropdown extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedProperty: '',
      selectedType: ''
    }
    this.handleChangeItemProperty = this.handleChangeItemProperty.bind(this)
    this.handleChangeItemType = this.handleChangeItemType.bind(this)
  }

  componentDidMount () {
    this.props.setProperty('', this.props.keyName)
    this.selectProperty()
  }

  componentDidUpdate (prevProps) {
    if (!_.isEqual(this.props.selectedContext, prevProps.selectedContext)) {
      if (this.props.selectedContext.match && this.props.selectedContext.match.length > 0) {
        this.selectProperty()
      } else {
        this.initDropdown()
      }
    }
  }

  initDropdown () {
    this.setState({selectedProperty: '', selectedType: ''})
    this.props.removeProperty(this.props.keyName)
  }

  selectProperty () {
    if (Object.keys(this.props.selectedContext).length > 0) {
      let selectedProperty = ''
      if (this.props.selectedContext.match.find(w => w.inputKey === this.props.keyName)) {
        selectedProperty = this.props.selectedContext.match.filter(w => w.inputKey === this.props.keyName)[0].value
      }
      this.handleChangeItemProperty(selectedProperty)
    }
  }

  handleChangeItemProperty (selectedProperty) {
    this.setState({selectedProperty: selectedProperty})
    if (selectedProperty) {
      this.props.setProperty(this.props.keyName, selectedProperty)
    } else {
      this.props.removeProperty(this.props.keyName)
    }
  }

  handleChangeItemType (selectedType) {
    this.setState({selectedType: selectedType})
    this.props.setItemType(this.props.keyName, this.state.selectedProperty, selectedType)
  }

  render () {
    const properties = this.props.selectedContext.properties
    const types = this.props.selectedContext.types
    const vocabularyType = this.props.vocabularyType[this.props.keyName]
    const disabled = vocabularyType !== ''
    return (
      <FormGroup>
        <Col className="input_wrapper mapping_flex">
          <Col className="mapping_radio_wrapper">
            <Radio key={`id-${this.props.keyName}`} checked={vocabularyType === 'id'}
                   onChange={e => this.props.handleChangeType(this.props, 'id')}>@id</Radio>

            <Radio key={`type-${this.props.keyName}`} checked={vocabularyType === 'type'}
                   onChange={e => this.props.handleChangeType(this.props, 'type')}>@type</Radio>

            <Radio key={`none-${this.props.keyName}`} checked={vocabularyType === ''}
                   onChange={e => this.props.handleChangeType(this.props, '')}>指定なし</Radio>
          </Col>

          <Col className="input_heading mapping_heading" md={2}>{this.props.keyName}</Col>
          <div className="mapping_select_wrapper">
            <div className="mapping_select">
              <FormControl componentClass="select"
                           key={`property-${this.props.keyName}`}
                           id={`property-${this.props.keyName}`}
                           onChange={e => this.handleChangeItemProperty(e.target.value)}
                           value={this.state.selectedProperty}
                           disabled={disabled}>
                <option key="default" label="Select Property" value="">Select Property</option>
                {Object.keys(this.props.selectedContext).length > 0 && properties &&
                Object.keys(properties).length > 0 &&
                Object.keys(properties).map((key, i) => {
                  return <option key={i} value={properties[key]}>{properties[key]}</option>
                })}
              </FormControl>
            </div>
            <div className="mapping_select">
              <FormControl componentClass="select"
                           key={`itemType-${this.props.keyName}`}
                           id={`itemType-${this.props.keyName}`}
                           onChange={e => this.handleChangeItemType(e.target.value)}
                           value={this.state.selectedType}
                           disabled={disabled}>
                <option key="default" label="Select Type" value="">Select Property</option>
                {Object.keys(this.props.selectedContext).length > 0 && types &&
                Object.keys(types).length > 0 &&
                Object.keys(types).map((key, i) => {
                  return <option key={i} value={types[key]}>{types[key]}</option>
                })}
              </FormControl>
            </div>
          </div>
        </Col>
      </FormGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MappingDropdown.js